import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { location: '_location' };
var _createRequest = { address: '_address' };
var _createResponse = {};
var _deleteRequest = {};
var _deleteResponse = {};
var _getAddressRequest = {};
var _getAddressResponse = { address: '_address' };
var _getDefaultRequest = {};
var _getDefaultResponse = { address: '_address' };
var _listRequest = {};
var _listResponse = { addresses: '_address' };
var _location = { latitude: 'DOUBLE', longitude: 'DOUBLE' };
var _setAsDefaultRequest = {};
var _setAsDefaultResponse = {};
var _updateRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    address: '_address',
};
var _updateResponse = {};
function resolveWixAddressesApiV1AddressesUrl(opts) {
    var domainToMappings = {
        'addresses.wixapps.net': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/addresses-web',
                destPath: '/api',
            },
        ],
        'www.cartscheckout.com': [
            {
                srcPath: '/_api/addresses-web',
                destPath: '/api',
            },
        ],
        'ecom._base_domain_': [
            {
                srcPath: '/_api/addresses-web',
                destPath: '/api',
            },
        ],
        'ecom.wixapps.net': [
            {
                srcPath: '/_api/addresses-web',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/addresses-web',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/addresses-web',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Create a new address, and set the address as default or not.
 * The first address is always set as default.
 * An address id is returned to access the newly created address
 */
export function create(payload) {
    var _a = serializer(_createRequest, {
        _address: _address,
        _location: _location,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createResponse, {}).fromJSON;
    function __create(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addresses.api.v1.address',
            method: 'POST',
            methodFqn: 'wix.addresses.api.v1.Addresses.Create',
            url: resolveWixAddressesApiV1AddressesUrl({
                protoPath: '/api/v1/addresses',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __create.fromReq = fromReq;
    __create.__isAmbassador = true;
    return __create;
}
/**
 * Delete an address form the list
 * Delete the default address will set the next avilable address as the new default
 */
export function _delete(payload) {
    var _a = serializer(_deleteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteResponse, {}).fromJSON;
    function ___delete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addresses.api.v1.address',
            method: 'DELETE',
            methodFqn: 'wix.addresses.api.v1.Addresses._Delete',
            url: resolveWixAddressesApiV1AddressesUrl({
                protoPath: '/api/v1/addresses/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    ___delete.fromReq = fromReq;
    ___delete.__isAmbassador = true;
    return ___delete;
}
/** Update an address, use a fieldMask to update a part of the fields */
export function update(payload) {
    var _a = serializer(_updateRequest, {
        _address: _address,
        _location: _location,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateResponse, {}).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addresses.api.v1.address',
            method: 'PATCH',
            methodFqn: 'wix.addresses.api.v1.Addresses.Update',
            url: resolveWixAddressesApiV1AddressesUrl({
                protoPath: '/api/v1/addresses/{address.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/**
 * Mark address as the default.
 * There can only be one default address
 * Throw exception when id is not of a valid address
 */
export function setAsDefault(payload) {
    var _a = serializer(_setAsDefaultRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setAsDefaultResponse, {}).fromJSON;
    function __setAsDefault(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addresses.api.v1.address',
            method: 'POST',
            methodFqn: 'wix.addresses.api.v1.Addresses.SetAsDefault',
            url: resolveWixAddressesApiV1AddressesUrl({
                protoPath: '/api/v1/addresses/default',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setAsDefault.fromReq = fromReq;
    __setAsDefault.__isAmbassador = true;
    return __setAsDefault;
}
/** Retrieve the default address */
export function getDefault(payload) {
    var _a = serializer(_getDefaultRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDefaultResponse, {
        _address: _address,
        _location: _location,
    }).fromJSON;
    function __getDefault(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addresses.api.v1.address',
            method: 'GET',
            methodFqn: 'wix.addresses.api.v1.Addresses.GetDefault',
            url: resolveWixAddressesApiV1AddressesUrl({
                protoPath: '/api/v1/addresses/get-default-address',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDefault.fromReq = fromReq;
    __getDefault.__isAmbassador = true;
    return __getDefault;
}
/** Retrieve an address by id, and whether or not it is the default address */
export function getAddress(payload) {
    var _a = serializer(_getAddressRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAddressResponse, {
        _address: _address,
        _location: _location,
    }).fromJSON;
    function __getAddress(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addresses.api.v1.address',
            method: 'GET',
            methodFqn: 'wix.addresses.api.v1.Addresses.GetAddress',
            url: resolveWixAddressesApiV1AddressesUrl({
                protoPath: '/api/v1/addresses/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAddress.fromReq = fromReq;
    __getAddress.__isAmbassador = true;
    return __getAddress;
}
/** Retrieve a list of all the site member's addresses (not including deleted addresses) */
export function list(payload) {
    var _a = serializer(_listRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listResponse, {
        _address: _address,
        _location: _location,
    }).fromJSON;
    function __list(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addresses.api.v1.address',
            method: 'GET',
            methodFqn: 'wix.addresses.api.v1.Addresses.List',
            url: resolveWixAddressesApiV1AddressesUrl({
                protoPath: '/api/v1/addresses',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixAddressesApiV1AddressesUrl({
                        protoPath: '/api/v1/addresses',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __list.fromReq = fromReq;
    __list.__isAmbassador = true;
    return __list;
}
//# sourceMappingURL=http.impl.js.map